var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _g25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 160 108"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__b",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.908 7.092H48.09V70.91h63.818z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.998 68.174c16.091 0 29.174-13.083 29.174-29.174S96.09 9.826 79.998 9.826 50.824 22.91 50.824 39s13.083 29.174 29.174 29.174"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__c",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.908 39c0 17.642-14.268 31.91-31.91 31.91-17.64 0-31.908-14.268-31.908-31.91 0-17.64 14.268-31.908 31.909-31.908S111.908 21.36 111.908 39"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__d",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M80 65.758c14.77 0 26.758-11.988 26.758-26.758S94.77 12.242 80 12.242 53.242 24.231 53.242 39c0 14.77 11.989 26.758 26.758 26.758"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__e",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m80.775 41.371-.091 1.094 1.413-.228-.045.638-1.414.228-.182 2.507c-.046.593.137.867.684.775.273-.045.41-.09.593-.136v.638c-.183.091-.502.182-.867.273-.456.092-.82 0-1.048-.182-.228-.228-.32-.593-.274-1.14l.183-2.552-.82.136.045-.638.82-.136.046-.867z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__f",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87.887 43.604c-.137 1.732-1.55 2.69-2.872 2.872-1.459.228-2.507-.501-2.416-1.96.091-1.55 1.368-2.644 2.826-2.872 1.596-.273 2.553.547 2.462 1.96m-4.24.73c-.09 1.002.548 1.686 1.505 1.55.912-.137 1.687-1.003 1.778-2.052.045-.775-.32-1.687-1.505-1.504-1.14.137-1.732 1.14-1.777 2.006"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__g",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.538 43.787c-.045.502-.045.912-.045 1.277l-.866.136v-.729h-.046a2.65 2.65 0 0 1-1.823 1.14c-.866.136-1.824-.137-1.732-1.732l.182-2.736.957-.136-.182 2.552c-.046.867.228 1.46 1.094 1.277.638-.091 1.14-.547 1.322-1.003.045-.137.091-.274.137-.456l.182-2.826.957-.137z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__h",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.316 41.6c.046-.548.046-1.003.046-1.46l.866-.136v.912h.046c.273-.684.911-1.14 1.55-1.277.09 0 .182 0 .273-.045l-.045.775c-.092 0-.183 0-.32.045-.683.091-1.23.639-1.367 1.277-.046.136-.046.273-.046.41l-.182 2.461-.957.137z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__i",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.642 43.377c.273.091.775.183 1.276.137.684-.091 1.049-.456 1.094-.866s-.228-.593-.911-.684c-.958-.137-1.368-.547-1.322-1.094.045-.73.82-1.459 1.96-1.64.547-.092 1.003-.046 1.276.09l-.273.638c-.183-.09-.593-.182-1.094-.09-.593.09-.912.41-.912.774-.046.365.274.502.957.638.912.137 1.368.456 1.322 1.186-.045.82-.82 1.504-2.097 1.732-.592.09-1.14.045-1.504-.091z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__j",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.898 41.827s3.009-.41 3.51-3.008c0 0 .32-2.052-2.234-1.459 0 0-1.413.228-1.823 2.735l-.775 7.522-2.28.364.73-8.023s.456-3.966 4.148-4.65c0 0 3.283-.638 4.377 1.779 0 0 1.55 4.239-3.42 6.29 0 0-1.868.684-2.37.775z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__k",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m75.624 34.078-2.37.365-.547 7.476 2.325-.365z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__l",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.173 33.94s.183.137.73 0c0 0 1.823-.957 2.279-1.276 0 0 2.37-1.368 3.875-.091 0 0 3.829-2.78 5.47-.502 0 0 .638.456.273 2.872l-.273 4.285-2.553.456s.182-.638.273-2.553c0 0 .274-3.19.183-3.373-.091-.182-.137-.456-.456-.456 0 0-2.142.638-2.325 1.049l-.365 5.652-2.461.456s.547-5.516.456-5.835c-.091-.365-.228-.456-.638-.365 0 0-.958.137-2.189 1.049l-.364 5.561-2.416.365z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__m",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.662 35.308s-3.282 1.277-3.738 2.006l-.41 5.242-2.28.41.456-7.339s.183.092.957 0c0 0 3.055-1.823 4.468-2.187z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__n",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.55 29.93s-3.737-1.14-6.062 2.507c0 0-2.826 4.832 2.142 6.063 0 0 3.966.775 5.926-3.51 0 0 1.687-3.692-2.005-5.06"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__o",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M96.544 31.981s-2.006-.501-2.963 1.322c0 0-1.413 2.462.593 3.191 0 0 2.188.41 3.054-1.823.045-.046.73-2.097-.684-2.69"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__p",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.106 28.38-.319-.866-.365.866z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__q",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.242 28.425.456.502.365-.866"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__r",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.789 29.701.866-.364-.866-.32z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__s",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.741 29.838-.456.456.821.364"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__t",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m100.422 30.385.365.866.319-.866z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__u",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m100.285 30.294-.456-.456-.364.866"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__v",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m99.739 29.063-.821.319.82.319z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__w",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m99.828 28.927.456-.456-.866-.41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__x",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.743 29.383a.935.935 0 0 1-.958.957.934.934 0 0 1-.957-.957c0-.547.456-.957.957-.957.502 0 .958.41.958.957"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "login_svg__y",
    width: 64,
    height: 64,
    x: 48,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.09 39c0 17.642 14.268 31.91 31.909 31.91S111.908 56.642 111.908 39c0-17.64-14.268-31.908-31.91-31.908C62.359 7.092 48.09 21.36 48.09 39"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D47519",
    d: "M100.785 30.477a1.11 1.11 0 0 1-1.094-1.094 1.11 1.11 0 0 1 1.094-1.094c.593 0 1.094.502 1.094 1.094-.045.593-.501 1.094-1.094 1.094m0-1.96a.866.866 0 0 0-.866.866c0 .502.365.866.866.866a.866.866 0 1 0 0-1.732"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#login_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M91.209 97.226h1.379v-5.067h1.933v-1.323h-5.209v1.323h1.897z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M91.209 97.226h1.379v-5.067h1.933v-1.323h-5.209v1.323h1.897z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M47.836 97.518a1.9 1.9 0 0 0-.794-.155q-.4 0-.725.142-.326.142-.522.396-.198.254-.229.603h.844a.46.46 0 0 1 .21-.326.77.77 0 0 1 .416-.105q.225 0 .36.077.137.076.2.234.065.158.065.397h-.805q-.465 0-.77.129a1 1 0 0 0-.458.355.9.9 0 0 0-.151.522q-.001.27.125.493a.9.9 0 0 0 .39.355q.264.131.67.132.195 0 .355-.042t.29-.119a1.06 1.06 0 0 0 .394-.413l.096.497h.735v-2.012q0-.426-.18-.716a1.16 1.16 0 0 0-.516-.445zm-.214 1.805a1.2 1.2 0 0 1-.074.3.8.8 0 0 1-.151.244.7.7 0 0 1-.529.229.7.7 0 0 1-.25-.045.37.37 0 0 1-.168-.13.37.37 0 0 1-.058-.212q0-.116.058-.206t.183-.139a.9.9 0 0 1 .326-.048h.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M47.836 97.518a1.9 1.9 0 0 0-.794-.155q-.4 0-.725.142-.326.142-.522.396-.198.254-.229.603h.844a.46.46 0 0 1 .21-.326.77.77 0 0 1 .416-.105q.225 0 .36.077.137.076.2.234.065.158.065.397h-.805q-.465 0-.77.129a1 1 0 0 0-.458.355.9.9 0 0 0-.151.522q-.001.27.125.493a.9.9 0 0 0 .39.355q.264.131.67.132.195 0 .355-.042t.29-.119a1.06 1.06 0 0 0 .394-.413l.096.497h.735v-2.012q0-.426-.18-.716a1.16 1.16 0 0 0-.516-.445zm-.214 1.805a1.2 1.2 0 0 1-.074.3.8.8 0 0 1-.151.244.7.7 0 0 1-.529.229.7.7 0 0 1-.25-.045.37.37 0 0 1-.168-.13.37.37 0 0 1-.058-.212q0-.116.058-.206t.183-.139a.9.9 0 0 1 .326-.048h.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M57.723 90.98v15.411q.002.021.023.023a.957.957 0 0 0 .957-.957V90a.98.98 0 0 0-.98.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M57.723 90.98v15.411q.002.021.023.023a.957.957 0 0 0 .957-.957V90a.98.98 0 0 0-.98.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M79.466 90c-1.947 0-3.602 1.095-4.299 2.629-.69-1.54-2.365-2.629-4.323-2.629-2.576 0-4.664 1.885-4.664 4.21v.04c.023.817.249 2.46 1.429 4.595 0 0 4.419 2.481 10.2-3.484l-1.551.926s-1.53-.489-1.658-.535c-.208-.076-.247-.11-.247-.247 0-.084.042-.158.107-.203.04-.027.502-.397.502-.397s3.35.012 3.368 0l.108-.094 1.027-.87c.382-.382.886-.496 1.126-.256.24.241.126.744-.256 1.126l-.675.66-.383.377-.315 3.427s-.447.418-.479.455a.25.25 0 0 1-.214.085c-.135-.014-.165-.056-.219-.27-.033-.132-.359-1.705-.359-1.705l1.26-1.676-3.737 3.623s-2.641 2.46-5.497 2.041c1.185 1.383 2.776 2.881 4.896 4.427a1.1 1.1 0 0 0 .54.162c.218 0 .412-.066.597-.19 7.542-5.502 8.35-10.398 8.38-12.015-.002-2.326-2.09-4.21-4.666-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M79.466 90c-1.947 0-3.602 1.095-4.299 2.629-.69-1.54-2.365-2.629-4.323-2.629-2.576 0-4.664 1.885-4.664 4.21v.04c.023.817.249 2.46 1.429 4.595 0 0 4.419 2.481 10.2-3.484l-1.551.926s-1.53-.489-1.658-.535c-.208-.076-.247-.11-.247-.247 0-.084.042-.158.107-.203.04-.027.502-.397.502-.397s3.35.012 3.368 0l.108-.094 1.027-.87c.382-.382.886-.496 1.126-.256.24.241.126.744-.256 1.126l-.675.66-.383.377-.315 3.427s-.447.418-.479.455a.25.25 0 0 1-.214.085c-.135-.014-.165-.056-.219-.27-.033-.132-.359-1.705-.359-1.705l1.26-1.676-3.737 3.623s-2.641 2.46-5.497 2.041c1.185 1.383 2.776 2.881 4.896 4.427a1.1 1.1 0 0 0 .54.162c.218 0 .412-.066.597-.19 7.542-5.502 8.35-10.398 8.38-12.015-.002-2.326-2.09-4.21-4.666-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M112.641 97.273c.16 0 .404-.018.526-.047v-1.267c-.263 0-.451-.085-.451-.544v-4.58h-1.361v5.067c0 .986.601 1.37 1.286 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M112.641 97.273c.16 0 .404-.018.526-.047v-1.267c-.263 0-.451-.085-.451-.544v-4.58h-1.361v5.067c0 .986.601 1.37 1.286 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M94.215 97.226h1.37v-3.049c.3-.263.73-.319 1.116-.319h.31V92.61c-.122-.075-.328-.085-.469-.085-.498 0-.929.31-1.248.666a1.33 1.33 0 0 0-1.08-.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M94.215 97.226h1.37v-3.049c.3-.263.73-.319 1.116-.319h.31V92.61c-.122-.075-.328-.085-.469-.085-.498 0-.929.31-1.248.666a1.33 1.33 0 0 0-1.08-.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M25 100.69h2.965v-.703H25.87v-1.25h1.902v-.678H25.87V96.88h2.095v-.702H25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M25 100.69h2.965v-.703H25.87v-1.25h1.902v-.678H25.87V96.88h2.095v-.702H25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M36.605 97.861a1.1 1.1 0 0 0-.426-.368 1.4 1.4 0 0 0-.612-.128q-.445 0-.803.222t-.56.606a1.85 1.85 0 0 0-.204.88c0 .33.066.612.2.87q.201.387.552.606.351.22.797.22.27 0 .47-.071.2-.072.345-.194a1.4 1.4 0 0 0 .241-.258l.098.445h.773v-4.642h-.87v1.811zm-.09 1.696a.8.8 0 0 1-.306.332.86.86 0 0 1-.454.119.84.84 0 0 1-.759-.45 1.05 1.05 0 0 1-.112-.498c0-.19.037-.341.112-.484a.84.84 0 0 1 .758-.451q.257 0 .454.12.196.12.306.331.11.214.11.49 0 .278-.11.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M36.605 97.861a1.1 1.1 0 0 0-.426-.368 1.4 1.4 0 0 0-.612-.128q-.445 0-.803.222t-.56.606a1.85 1.85 0 0 0-.204.88c0 .33.066.612.2.87q.201.387.552.606.351.22.797.22.27 0 .47-.071.2-.072.345-.194a1.4 1.4 0 0 0 .241-.258l.098.445h.773v-4.642h-.87v1.811zm-.09 1.696a.8.8 0 0 1-.306.332.86.86 0 0 1-.454.119.84.84 0 0 1-.759-.45 1.05 1.05 0 0 1-.112-.498c0-.19.037-.341.112-.484a.84.84 0 0 1 .758-.451q.257 0 .454.12.196.12.306.331.11.214.11.49 0 .278-.11.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M31.397 97.53a1.3 1.3 0 0 0-.684-.167q-.38 0-.654.168a1.17 1.17 0 0 0-.423.438l-.064-.529h-.767v3.25h.87v-1.735q0-.27.096-.46a.7.7 0 0 1 .268-.294.74.74 0 0 1 .39-.103q.342 0 .506.206t.164.593v1.792h.864v-1.876q0-.471-.145-.793a1.07 1.07 0 0 0-.422-.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M31.397 97.53a1.3 1.3 0 0 0-.684-.167q-.38 0-.654.168a1.17 1.17 0 0 0-.423.438l-.064-.529h-.767v3.25h.87v-1.735q0-.27.096-.46a.7.7 0 0 1 .268-.294.74.74 0 0 1 .39-.103q.342 0 .506.206t.164.593v1.792h.864v-1.876q0-.471-.145-.793a1.07 1.07 0 0 0-.422-.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M43.288 96.05h-.87v4.643h.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M43.288 96.05h-.87v4.643h.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M40.832 97.576a1.6 1.6 0 0 0-.845-.213 1.7 1.7 0 0 0-.873.223 1.53 1.53 0 0 0-.584.612q-.206.39-.206.9c0 .34.07.621.21.874q.21.377.586.587.377.21.867.21.38 0 .69-.142a1.5 1.5 0 0 0 .825-.934h-.889a.65.65 0 0 1-.236.264.7.7 0 0 1-.396.103.8.8 0 0 1-.419-.107.73.73 0 0 1-.281-.303 1 1 0 0 1-.095-.37h2.393a1 1 0 0 0 .014-.165v-.145q0-.458-.2-.82a1.5 1.5 0 0 0-.562-.573zm-1.629 1.173a1 1 0 0 1 .085-.27.7.7 0 0 1 .293-.306.85.85 0 0 1 .406-.1q.303 0 .507.18.203.18.222.496z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M40.832 97.576a1.6 1.6 0 0 0-.845-.213 1.7 1.7 0 0 0-.873.223 1.53 1.53 0 0 0-.584.612q-.206.39-.206.9c0 .34.07.621.21.874q.21.377.586.587.377.21.867.21.38 0 .69-.142a1.5 1.5 0 0 0 .825-.934h-.889a.65.65 0 0 1-.236.264.7.7 0 0 1-.396.103.8.8 0 0 1-.419-.107.73.73 0 0 1-.281-.303 1 1 0 0 1-.095-.37h2.393a1 1 0 0 0 .014-.165v-.145q0-.458-.2-.82a1.5 1.5 0 0 0-.562-.573zm-1.629 1.173a1 1 0 0 1 .085-.27.7.7 0 0 1 .293-.306.85.85 0 0 1 .406-.1q.303 0 .507.18.203.18.222.496z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M50.467 97.153q0-.2.087-.28t.293-.081h.27v-.741h-.399q-.342 0-.596.11a.8.8 0 0 0-.39.348q-.135.239-.135.645v.29h-.445v.728h.445v2.521h.87v-2.52h.703v-.73h-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M50.467 97.153q0-.2.087-.28t.293-.081h.27v-.741h-.399q-.342 0-.596.11a.8.8 0 0 0-.39.348q-.135.239-.135.645v.29h-.445v.728h.445v2.521h.87v-2.52h.703v-.73h-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M116.687 92.524a2.43 2.43 0 0 0-1.444.488l-.01.01v-.817c0-.76-.61-1.37-1.37-1.37v6.39h1.37v-2.898c.263-.253.648-.469 1.022-.469.423 0 .516.263.516.648v2.72h1.37v-2.795c0-1.004-.216-1.905-1.455-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M116.687 92.524a2.43 2.43 0 0 0-1.444.488l-.01.01v-.817c0-.76-.61-1.37-1.37-1.37v6.39h1.37v-2.898c.263-.253.648-.469 1.022-.469.423 0 .516.263.516.648v2.72h1.37v-2.795c0-1.004-.216-1.905-1.455-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "m113.697 103.999-1.117-2.571h-1.389l1.811 4.175-.957 2.195h1.399l2.758-6.37h-1.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "m113.697 103.999-1.117-2.571h-1.389l1.811 4.175-.957 2.195h1.399l2.758-6.37h-1.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M121.063 92.535c-1.435 0-2.29 1.042-2.29 2.403s.882 2.373 2.29 2.373c.723 0 1.389-.216 1.867-.769l-.844-.676c-.281.291-.535.385-.948.385-.6 0-1.041-.3-1.107-.919h3.304a3 3 0 0 0 .028-.413c0-1.379-.929-2.383-2.3-2.383m-1.004 1.82c.113-.497.507-.76 1.014-.76.544 0 .873.253 1.004.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M121.063 92.535c-1.435 0-2.29 1.042-2.29 2.403s.882 2.373 2.29 2.373c.723 0 1.389-.216 1.867-.769l-.844-.676c-.281.291-.535.385-.948.385-.6 0-1.041-.3-1.107-.919h3.304a3 3 0 0 0 .028-.413c0-1.379-.929-2.383-2.3-2.383m-1.004 1.82c.113-.497.507-.76 1.014-.76.544 0 .873.253 1.004.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M129.813 93.191a1.33 1.33 0 0 0-1.079-.553v4.588h1.37v-3.049c.3-.263.731-.319 1.116-.319h.31V92.61c-.122-.075-.328-.085-.468-.085-.498 0-.929.31-1.249.666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M129.813 93.191a1.33 1.33 0 0 0-1.079-.553v4.588h1.37v-3.049c.3-.263.731-.319 1.116-.319h.31V92.61c-.122-.075-.328-.085-.468-.085-.498 0-.929.31-1.249.666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M134.997 93.895v-1.257h-1.024v-1.107h-1.106l-.282 1.107h-.694v1.257h.713v1.802c0 1.136.619 1.604 1.632 1.604.31 0 .544-.037.761-.103v-1.285a1.6 1.6 0 0 1-.479.075c-.328 0-.545-.169-.545-.591v-1.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M134.997 93.895v-1.257h-1.024v-1.107h-1.106l-.282 1.107h-.694v1.257h.713v1.802c0 1.136.619 1.604 1.632 1.604.31 0 .544-.037.761-.103v-1.285a1.6 1.6 0 0 1-.479.075c-.328 0-.545-.169-.545-.591v-1.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M125.959 92.525a4.15 4.15 0 0 0-1.642.356l.375.995c.329-.14.704-.216 1.07-.216.403 0 .75.188.75.629v.262c-.281-.197-.638-.29-1.079-.29-.948 0-1.679.59-1.679 1.548s.741 1.54 1.67 1.54c.478 0 .901-.113 1.248-.441l.094.318h1.117v-2.88c0-1.23-.779-1.82-1.924-1.82m-.216 3.847c-.347 0-.769-.15-.769-.563s.404-.563.769-.563c.366 0 .779.131.779.563 0 .433-.431.563-.779.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M125.959 92.525a4.15 4.15 0 0 0-1.642.356l.375.995c.329-.14.704-.216 1.07-.216.403 0 .75.188.75.629v.262c-.281-.197-.638-.29-1.079-.29-.948 0-1.679.59-1.679 1.548s.741 1.54 1.67 1.54c.478 0 .901-.113 1.248-.441l.094.318h1.117v-2.88c0-1.23-.779-1.82-1.924-1.82m-.216 3.847c-.347 0-.769-.15-.769-.563s.404-.563.769-.563c.366 0 .779.131.779.563 0 .433-.431.563-.779.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M110.646 104.205v-4.578h-1.361v5.066c0 .986.601 1.37 1.286 1.37.16 0 .403-.019.526-.047v-1.267c-.263 0-.451-.084-.451-.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M110.646 104.205v-4.578h-1.361v5.066c0 .986.601 1.37 1.286 1.37.16 0 .403-.019.526-.047v-1.267c-.263 0-.451-.084-.451-.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M96.385 101.316a4.1 4.1 0 0 0-1.642.357l.375.994a2.8 2.8 0 0 1 1.07-.216c.403 0 .75.188.75.629v.262c-.282-.197-.638-.29-1.079-.29-.948 0-1.68.591-1.68 1.548s.742 1.539 1.67 1.539c.479 0 .901-.112 1.249-.44l.093.318h1.117v-2.881c0-1.229-.779-1.82-1.924-1.82m-.216 3.847c-.347 0-.769-.15-.769-.563s.403-.563.77-.563c.365 0 .778.131.778.563 0 .433-.431.563-.779.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M96.385 101.316a4.1 4.1 0 0 0-1.642.357l.375.994a2.8 2.8 0 0 1 1.07-.216c.403 0 .75.188.75.629v.262c-.282-.197-.638-.29-1.079-.29-.948 0-1.68.591-1.68 1.548s.742 1.539 1.67 1.539c.479 0 .901-.112 1.249-.44l.093.318h1.117v-2.881c0-1.229-.779-1.82-1.924-1.82m-.216 3.847c-.347 0-.769-.15-.769-.563s.403-.563.77-.563c.365 0 .778.131.778.563 0 .433-.431.563-.779.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M100.122 97.226h1.116v-2.88c0-1.23-.778-1.82-1.924-1.82a4.15 4.15 0 0 0-1.642.356l.376.994c.328-.14.703-.216 1.07-.216.402 0 .75.188.75.629v.262c-.282-.197-.638-.29-1.08-.29-.947 0-1.679.59-1.679 1.548s.742 1.54 1.67 1.54c.479 0 .901-.113 1.249-.441zm-1.023-.854c-.348 0-.77-.15-.77-.563s.404-.563.77-.563.778.131.778.563c0 .433-.43.563-.778.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M100.122 97.226h1.116v-2.88c0-1.23-.778-1.82-1.924-1.82a4.15 4.15 0 0 0-1.642.356l.376.994c.328-.14.703-.216 1.07-.216.402 0 .75.188.75.629v.262c-.282-.197-.638-.29-1.08-.29-.947 0-1.679.59-1.679 1.548s.742 1.54 1.67 1.54c.479 0 .901-.113 1.249-.441zm-1.023-.854c-.348 0-.77-.15-.77-.563s.404-.563.77-.563.778.131.778.563c0 .433-.43.563-.778.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M90.11 106.017h1.369v-2.421h2.186v-1.314h-2.186v-1.332h2.656v-1.323h-4.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M90.11 106.017h1.369v-2.421h2.186v-1.314h-2.186v-1.332h2.656v-1.323h-4.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M104.71 101.316c-.619 0-1.135.263-1.605.657-.225-.498-.666-.657-1.191-.657-.629 0-1.174.263-1.633.676a1.28 1.28 0 0 0-1.069-.563h-.056v4.588h1.37v-2.899c.243-.253.573-.469.938-.469.413 0 .488.291.488.648v2.721h1.37v-2.899c.253-.253.573-.469.948-.469.14 0 .253.038.338.123.093.084.14.262.14.525v2.721h1.379v-2.796c0-.985-.205-1.905-1.416-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M104.71 101.316c-.619 0-1.135.263-1.605.657-.225-.498-.666-.657-1.191-.657-.629 0-1.174.263-1.633.676a1.28 1.28 0 0 0-1.069-.563h-.056v4.588h1.37v-2.899c.243-.253.573-.469.938-.469.413 0 .488.291.488.648v2.721h1.37v-2.899c.253-.253.573-.469.948-.469.14 0 .253.038.338.123.093.084.14.262.14.525v2.721h1.379v-2.796c0-.985-.205-1.905-1.416-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "m110.32 96.541-.844-.676c-.281.291-.535.385-.948.385-.601 0-1.041-.3-1.107-.919h3.303c.019-.13.028-.272.028-.413 0-1.379-.929-2.383-2.298-2.383-1.37 0-2.29 1.042-2.29 2.403s.883 2.373 2.29 2.373c.723 0 1.389-.216 1.867-.769zm-1.858-2.946c.544 0 .873.253 1.004.76h-2.017c.113-.497.507-.76 1.013-.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "m110.32 96.541-.844-.676c-.281.291-.535.385-.948.385-.601 0-1.041-.3-1.107-.919h3.303c.019-.13.028-.272.028-.413 0-1.379-.929-2.383-2.298-2.383-1.37 0-2.29 1.042-2.29 2.403s.883 2.373 2.29 2.373c.723 0 1.389-.216 1.867-.769zm-1.858-2.946c.544 0 .873.253 1.004.76h-2.017c.113-.497.507-.76 1.013-.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "m103.815 95.545-.986-2.908h-1.407l1.735 4.588h1.324l1.651-4.588h-1.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "m103.815 95.545-.986-2.908h-1.407l1.735 4.588h1.324l1.651-4.588h-1.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M108.385 101.428h-1.369v4.588h1.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M108.385 101.428h-1.369v4.588h1.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E272D",
    d: "M107.701 99.166a.81.81 0 0 0-.806.807.806.806 0 0 0 1.613 0 .8.8 0 0 0-.807-.807"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0F00",
    d: "M107.701 99.166a.81.81 0 0 0-.806.807.806.806 0 0 0 1.613 0 .8.8 0 0 0-.807-.807"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "login_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 90h110v17.797H25z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__a",
    width: 73.816,
    height: 80.818,
    x: 43.09,
    y: 3.092,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12844_65298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_12844_65298",
    result: "effect2_dropShadow_12844_65298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_12844_65298",
    result: "effect3_dropShadow_12844_65298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_12844_65298",
    result: "effect4_dropShadow_12844_65298"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_12844_65298",
    result: "effect5_dropShadow_12844_65298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_12844_65298",
    result: "shape"
  })))));
};
export default SvgLogin;